'use client';

import { memo, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { ImageLayout } from './image-layout';

export interface IImageSliderLayoutProps {
  className?: string;
  quick?: boolean;
  alt: string;
  link: { url: string; height?: number; width?: number }[][];
}

export const ImageSliderLayout = memo(function ImageSliderLayout(
  props: IImageSliderLayoutProps
) {
  const { link } = props;

  const [position, setPosition] = useState<number>(0);

  const increase = () => {
    let newPosition = position + 1;

    if (newPosition >= link.length) {
      newPosition = 0;
    }

    setPosition(newPosition);
  };

  const decrease = () => {
    let newPosition = position - 1;

    if (newPosition < 0) {
      newPosition = link.length - 1;
    }

    setPosition(newPosition);
  };

  return (
    <div className="relative h-full w-full">
      <ImageLayout
        className="object-cover w-full h-full"
        alt={props.alt}
        quick
        link={link[position]}
      ></ImageLayout>

      <button
        title="Left"
        type="button"
        onClick={decrease}
        className="absolute left-0 h-full top-0 hover:backdrop-blur-sm px-3"
      >
        <ChevronLeftIcon className="size-8 stroke-white" />
      </button>

      <button
        title="Right"
        type="button"
        onClick={increase}
        className="absolute right-0 h-full top-0 hover:backdrop-blur-sm px-3"
      >
        <ChevronRightIcon className="size-8 stroke-white" />
      </button>
    </div>
  );
});
